import { render } from "./location-on-icon.vue?vue&type=template&id=74e38fed"
import script from "./location-on-icon.vue?vue&type=script&lang=js"
export * from "./location-on-icon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__